import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
	imports: [ReactiveFormsModule, RouterLink],
})
export class LoginComponent {
	loginForm: FormGroup;
	error: boolean = false;

	constructor(
		private fb: FormBuilder,
		private authService: AuthService,
		private router: Router,
		private toastr: ToastrService,
	) {
		this.loginForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]],
		});
	}

	onSubmit(): void {
		if (this.loginForm.valid) {
			const email = this.loginForm.value.email;
			const password = this.loginForm.value.password;

			this.authService.login(email, password).subscribe({
				next: (data) => {
					if (data.result == 'ERROR') {
						this.error = true;
					} else {
						this.toastr.success('Connexion réussie !', 'Succès');
						this.router.navigate(['/']);
					}
				},
				error: () => {
					this.error = true;
				},
			});
		}
	}
}
